"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simplifyAmount = void 0;
const common_1 = require("@saffron/common");
const regex = /\s*[x×]\s*(\d+)\s?([^\s]+)\s(.+)/;
exports.simplifyAmount = (amount, str) => {
    const a1 = parseInt(amount);
    if (Number.isNaN(a1)) {
        return null;
    }
    let m;
    if ((m = regex.exec(str)) !== null) {
        const a2 = parseInt(m[1]);
        if (Number.isNaN(a2)) {
            return null;
        }
        const realAmount = a1 * a2;
        const unit = m[2].toLowerCase();
        return {
            amount: "" + realAmount,
            unit: common_1.unitMap[unit] ? unit : "",
            name: m[3],
        };
    }
    else {
        return null;
    }
};
//# sourceMappingURL=simplifyAmount.js.map